import {combineReducers} from 'redux';
import login from './login';
import loading from './loading';
import alert from './alert';
import modulo from './modulo';
import {LoadingState} from "./loading/types";
import {LoginState} from "./login/types";
import {AlertsState} from "./alert/types";
import {ModuloState} from "./modulo/types";

export default combineReducers({
    login,
    loading,
    alert,
    modulo,
});

export interface States {
  login: LoginState,
  loading: LoadingState,
  alert: AlertsState,
  modulo: ModuloState,
}